import React, { ComponentType, ReactNode, Suspense } from 'react';
import { CircularProgress } from '@mui/material';

export default function Suspenseful(Component: ComponentType): ReactNode {
    return (
        <Suspense fallback={<CircularProgress />}>
            <Component />
        </Suspense>
    )
}